const linzy = {
  "type": "{{value}}",
  "brand": "{{value}}",
  "period": "{{value}}",
  "radius-krivizny": "радиуса кривизны {{value}}",
  "cvet": "цвета {{value}}",
  "manufacturer": "производитель {{value}}",
};
const opravy = {
  "pol": "{{value}} оправы для очков",
  "brand": "{{value}}",
  "form": "форма {{value}}",
  "fcolor": "цвет {{value}}",
  "ftype": "тип оправы {{value}}",
  "material": "материал {{value}}",
  "lcolor": "цвет линз {{value}}",
};
const solncezashchitnyeOchki = {
  "pol": "{{value}} солнцезащитные очки",
  "brand": "{{value}}",
  "form": "форма {{value}}",
  "fcolor": "цвет {{value}}",
  "ftype": "тип оправы {{value}}",
  "material": "материал {{value}}",
  "lcolor": "цвет линз {{value}}",
};
const aksessuary = {
  "pol": "{{value}} аксессуары для линз",
  "type": "{{value}}",
  "brand": "{{value}}",
  "period": "{{value}}",
  "radius-krivizny": "радиуса кривизны {{value}}",
  "cvet": "цвета {{value}}",
  "manufacturer": "производитель {{value}}",
};

const formatFilterMeta = (selectedFilter, slug, appCfg, filters) => {
  const filter = {...selectedFilter};
  const rules = Boolean(slug === "linzy") ? linzy : Boolean(slug === "opravy") ? opravy : Boolean(slug === "aksessuary") ? aksessuary : solncezashchitnyeOchki;

  let messages = [];
  Object.keys(rules).map((key, index) => {
    if (filter?.[key] && Object.keys(filter?.[key]).length === 1) {
      const value = _getWorkValue(filter?.[key], (filters || []).find((t) => t.slug === key));
      const str = rules[key].replace("{{value}}", value);

      messages.push(str);

      delete filter[key]
    }
  });
  Object.keys(filter).map((key) => {
    const filterItem = (filters || []).find((t) => t.slug === key);
    const value = _getWorkValue(filter?.[key], filterItem);

    if (!!value) {
      const isHideFilterName = Boolean(key === "brand" && Object.keys(filter).length <= 1);
      const message = [
        Boolean(!isHideFilterName) && filterItem?.name,
        value
      ].filter((t) => !!t).join(" ")

      messages.push(message);
    }
  })
  messages = [messages.join(", ")];
  messages = messages.filter((t) => !!t);

  const city = appCfg?.city?.data?.prepositional || appCfg?.city?.model?.name || "";
  if (!!city && messages.length > 0) {
    messages.push(`в ${city}`)
  }

  if (messages.length <= 0) {
    return ""
  }

  // Добавление название категории
  if (!selectedFilter.pol && slug !== "linzy") {
    const unshiftMessage = Boolean(slug === "opravy") ? "оправы для очков" : Boolean(slug === "aksessuary") ? "аксессуары для линз" : "солнцезащитные очки"

    messages.unshift(unshiftMessage);
  }

  return messages.join(" ")
}
const _getWorkValue = (value, filters) => {
  if (!filters) {
    return ""
  }

  const variants = filters?.variants || [];

  let words = [];
  Object.keys(value).map((key) => {
    let label = variants.find((t) => t.slug === key)?.label;
    if (filters?.slug !== "manufacturer" && filters?.slug !== "brand") {
      label = (label || "").toLowerCase();
    }

    words.push(label)
  })

  return words.join(", ")
}

const formatFilterCanonical = (selectedFilter, filters) => {
  let filtersStr = [];

  const isMultiFilterCategory = Boolean(Object.keys(selectedFilter || {}).find((t) => Object.keys(selectedFilter[t] || {}).length > 1));
  if (!!isMultiFilterCategory) {
    return filtersStr
  }

  Object.keys(selectedFilter).map((key) => {
    const item = selectedFilter[key];

    filtersStr.push(`${key}=${Object.keys(item)?.[0]}`)
  })
  return filtersStr.join("/")
}

export {
  formatFilterMeta,
  formatFilterCanonical
}
